module.exports = __webpack_public_path__ + "static/face_shield-05166194eb42ccc2030ca043372dd852.png";